import * as tslib_1 from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { Debounce } from "@/decorators";
let ListHeader = class ListHeader extends Vue {
    constructor() {
        super(...arguments);
        this.keyword = '';
    }
    handleClick() {
        this.$emit("search", this.keyword.trim());
    }
    addTestPaper() {
        this.$router.push({
            name: "TestPaperEdit",
            params: {
                step: '1'
            }
        });
    }
};
tslib_1.__decorate([
    Debounce(300)
], ListHeader.prototype, "handleClick", null);
ListHeader = tslib_1.__decorate([
    Component({
        name: 'ListHeader',
    })
], ListHeader);
export default ListHeader;
